import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const TableWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: theme.palette.mode === 'dark' 
    ? '0 2px 10px rgba(0, 0, 0, 0.2)' 
    : '0 2px 10px rgba(0, 0, 0, 0.05)',
  '& .table-container': {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-y pan-x',
    msOverflowStyle: '-ms-autohiding-scrollbar',
    scrollbarWidth: 'thin',
    paddingBottom: '30px',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.mode === 'dark' 
        ? 'rgba(255, 255, 255, 0.2)' 
        : 'rgba(0, 0, 0, 0.2)',
      borderRadius: '3px'
    }
  },
  '& .MuiTable-root': {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  },
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
    '& .MuiTableCell-root': {
      backgroundColor: theme.palette.mode === 'dark' 
        ? theme.palette.grey[900] 
        : '#f5f5f5',
      fontWeight: 700,
      position: 'sticky',
      top: 0
    }
  },
  // Desktop styles
  [theme.breakpoints.up('md')]: {
    '& .strike-cell': {
      width: '90px',
      minWidth: '90px',
      maxWidth: '90px',
      borderLeft: `1px solid ${theme.palette.divider}`,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    '& .ltp-cell': {
      fontWeight: 600,
      minWidth: '120px'
    }
  },
  // Mobile styles
  [theme.breakpoints.down('sm')]: {
    '& .table-container': {
      overflowX: 'scroll',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      '-webkit-overflow-scrolling': 'touch',
      scrollbarWidth: 'auto',
      maxWidth: '100%',
      width: '100%',
    },
    '& .MuiTable-root': {
      width: '600px', // Set a fixed width to ensure horizontal scrolling
      minWidth: '100%', 
      tableLayout: 'fixed'
    },
    '& .MuiTableHead-root': {
      display: 'table-header-group',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      '& .MuiTableRow-root': {
        display: 'table-row'
      }
    },
    '& .MuiTableBody-root': {
      display: 'table-row-group'
    },
    '& .MuiTableRow-root': {
      display: 'table-row'
    },
    '& .MuiTableCell-root': {
      display: 'table-cell',
      whiteSpace: 'nowrap'
    },
    '& .strike-cell': {
      width: '90px',
      minWidth: '90px',
      maxWidth: '90px',
      boxSizing: 'border-box',
      borderLeft: `1px solid ${theme.palette.divider}`,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    '& .ltp-cell': {
      width: '120px',
      minWidth: '120px',
      boxSizing: 'border-box',
      fontWeight: 600
    }
  }
}));

export default TableWrapper; 